export default {
    url: '/employee',
    template: '<ui-view></ui-view>',
    resolve: {
        countries (CountryResource) {
            return CountryResource.query().$promise;
        },
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise
    },
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/employee/index.js